// service-management.validators.ts

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const placementIdRequiredValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const isChargeable = group.get('isChargeable')?.value;
  const placementId = group.get('placementId')?.value;
  if (isChargeable && (!placementId || placementId === '')) {
    return { placementIdRequired: true };
  }
  if (placementId && placementId.trim() !== '' && !isChargeable) {
    return { invalidPlacementId: true };
  }
  return null;
};
